
export const CONFIG = {
  serverUrl: 'u2fgx45xxa-de.a.run.app'
}
